import { Coordinate, PlannedRouteTrail } from "atlasguides-web-common/src/functions/guides/dto/guide-geo.dto";
import { GuideGeoExt, PlannedRouteExt } from "commonTypes/GuideUse/guideGeo";

export class GeoRouteBuilder {

  private guideData: GuideGeoExt;
  private pins: number[][] = [];
  private route: PlannedRouteExt

  constructor(guide: GuideGeoExt, route: PlannedRouteExt) {
    this.guideData = guide;
    this.route = route;
  }

  public setPlannedRoute(route: PlannedRouteExt){
     this.route = route;
  }

  public setPins(pins: number[][]): void;
  public setPins(pins: string[]): void;
  public setPins(pins: number[][] | string[]): void {
    if (Array.isArray(pins) && pins.length > 0) {
      if (typeof pins[0] === "string") {
        // Assume each string is "lat,lng"
        this.pins = (pins as string[]).map(pinStr => {
          const [lat, lng] = pinStr.split(",").map(Number);
          return [lat, lng];
        });
      } 
      else {
        // Assume pins is Number[][]
        this.pins = pins as number[][];
      }
    } 
    else {
      this.pins = [];
    }
  }

  public buildTrail(): PlannedRouteTrail | null {
    // Build a trail based on pins using Dijkstra's algorithm

    if (!this.guideData.trails || this.guideData.trails.length === 0 || this.pins.length < 2) {
      return null;
    }

    const trail: PlannedRouteTrail = {
      id: this.route.id,
      type: '',
      stroke: '',
      trackId: '',
      trackName: this.route?.routeName || "",
      trackLength: this.route?.routeLength || 0,
      totalDescent: this.route?.totalDescent || 0,
      totalAscent: this.route?.totalAscent || 0,
      strokeWidth: 10,
      trackIsPrimary: false,
      geometry: {
        type: "LineString",
        coordinates: []
      }
    };

    const coordinates: Coordinate[] = this.guideData.dijkstraPath?.getDijkstraPathForLocations(this.pins, this.guideData, trail) ?? [];
    if (coordinates.length === 0){
      return null;
    }

    trail.geometry.coordinates = coordinates;

    return trail;
  }
}
